import LoadingIndicator from '@nobia/zeus-components/lib/loadingIndicator'
import React from 'react'
import styled from '@nobia/zeus-components/lib/styled'

const Loader = styled.div`
  height: 80vh;
  width: 100%;
  padding: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  > div > div {
    opacity: 1;
  }
`

export default () => (
  <Loader>
    <LoadingIndicator color="#192228" />
  </Loader>
)
